export default __webpack_public_path__ + "static/media/gallery-11-2.6ddbd6d9.webp";